'use client';

import { c as _c } from "react/compiler-runtime";
import type { NegociacaoDetailTab } from '../../types/negociacaoDetailTypes';
import { Button, Tabs } from '@/shared/components/ui';
interface NegociacaoDetailTabsProps {
  activeTab: NegociacaoDetailTab;
  onTabChange: (value: string) => void;
  showOutrasNegociacoes: boolean;
  onOpenDetails: () => void;
  isDetailsOpen: boolean;
  isReadOnly: boolean;
}
export function NegociacaoDetailTabs(t0) {
  const $ = _c(21);
  const {
    activeTab,
    onTabChange,
    showOutrasNegociacoes,
    onOpenDetails,
    isDetailsOpen,
    isReadOnly
  } = t0;
  let t1;
  if ($[0] !== isReadOnly) {
    t1 = isReadOnly ? "Resumo" : <><span className="sm:hidden">Acompanhar</span><span className="hidden sm:inline">Acompanhamento</span></>;
    $[0] = isReadOnly;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Tabs.Item value="resumo" className="h-12 sm:h-14">{t1}</Tabs.Item>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Tabs.Item value="chat" className="h-12 sm:h-14">Chat</Tabs.Item>;
    t4 = <Tabs.Item value="linha_do_tempo" className="h-12 sm:h-14">Linha do tempo</Tabs.Item>;
    t5 = <Tabs.Item value="documentos" className="h-12 sm:h-14">Documentos</Tabs.Item>;
    t6 = <Tabs.Item value="certificado" className="h-12 sm:h-14">Certificado da Negociação</Tabs.Item>;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== showOutrasNegociacoes) {
    t7 = showOutrasNegociacoes && <Tabs.Item value="outras_negociacoes" className="h-12 sm:h-14">Outras negociações</Tabs.Item>;
    $[8] = showOutrasNegociacoes;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== activeTab || $[11] !== onTabChange || $[12] !== t2 || $[13] !== t7) {
    t8 = <div className="min-w-0 flex-1 overflow-x-auto"><Tabs className="min-w-max" value={activeTab} onValueChange={onTabChange}>{t2}{t3}{t4}{t5}{t6}{t7}</Tabs></div>;
    $[10] = activeTab;
    $[11] = onTabChange;
    $[12] = t2;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isDetailsOpen || $[16] !== onOpenDetails) {
    t9 = <Button size="small" variant="neutral-secondary" className="shrink-0 min-[1280px]:hidden" id="negociacao-detalhes-trigger" aria-haspopup="dialog" aria-expanded={isDetailsOpen} onClick={onOpenDetails}>Detalhes</Button>;
    $[15] = isDetailsOpen;
    $[16] = onOpenDetails;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className="m-0 flex w-full shrink-0 items-center gap-2 border-b border-solid border-neutral-100 bg-white px-4 sm:px-5">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}